var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJbMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25559,
    y: 0.497781,
    width: 39.0455,
    height: 39.0455,
    rx: 19.5227,
    fill: "#F46940"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25559,
    y: 0.497781,
    width: 39.0455,
    height: 39.0455,
    rx: 19.5227,
    stroke: "white",
    strokeWidth: 0.954545
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6858 15.2891L31.6114 15.3655C33.0158 17.0063 33.8357 19.105 33.8357 21.6207C33.8357 28.3323 27.9997 31.1275 20.8007 31.1275C13.6018 31.1275 7.76575 28.3323 7.76575 21.6207C7.76575 15.6798 12.3384 12.0648 18.3815 11.3129L18.3718 10.7865C18.3437 9.25811 19.4792 7.99465 20.9079 7.9646C21.0752 7.96128 21.239 7.97494 21.3979 8.0041C22.414 8.19054 23.2309 9.01045 23.4729 10.0767C23.9254 8.95401 25.0399 8.25011 26.2249 8.43637C27.4592 8.63093 28.3608 9.72751 28.4314 11.0092C29.4564 10.257 30.8681 10.3851 31.7578 11.3749C32.7481 12.4771 32.716 14.2297 31.6858 15.2891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7842 19.5762C24.7842 20.4753 24.3745 21.2046 23.536 21.2046C22.6976 21.2046 22.2881 20.4757 22.2878 19.5762C22.2878 18.677 22.6976 17.9477 23.536 17.9477C24.3745 17.9477 24.7839 18.6767 24.7842 19.5762Z",
    fill: "#F46940"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2436 19.5762C19.2436 20.4753 18.8339 21.2046 17.9955 21.2046C17.157 21.2046 16.7476 20.4757 16.7473 19.5762C16.7473 18.677 17.157 17.9477 17.9955 17.9477C18.8339 17.9477 19.2433 18.6767 19.2436 19.5762Z",
    fill: "#F46940"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5153 24.8259C22.5083 24.8259 22.5025 24.8259 22.4954 24.8259C21.893 24.8201 21.314 24.5276 20.7677 23.9544C20.2214 24.5276 19.6424 24.8201 19.0399 24.8259C19.0341 24.8259 19.0271 24.8259 19.0201 24.8259C18.0854 24.8259 17.5192 24.1299 17.4572 24.0504C17.2596 23.7953 17.3063 23.428 17.5614 23.2292C17.8152 23.0327 18.1802 23.0771 18.3779 23.3286C18.3907 23.3438 18.6563 23.6561 19.0212 23.6561C19.0259 23.6561 19.0306 23.6561 19.0353 23.6561C19.3955 23.648 19.8085 23.3426 20.2308 22.7741C20.3407 22.6256 20.515 22.5378 20.6998 22.5378H20.8309C21.0157 22.5378 21.19 22.6256 21.2999 22.7741C21.7222 23.3426 22.1352 23.648 22.4954 23.6561C22.5001 23.6561 22.5048 23.6561 22.5095 23.6561C22.8815 23.6561 23.1505 23.3321 23.1529 23.3286C23.3505 23.0736 23.7167 23.0291 23.9717 23.2268C24.2267 23.4245 24.2712 23.7942 24.0735 24.0504C24.0115 24.1299 23.4453 24.8259 22.5107 24.8259H22.5153Z",
    fill: "#F46940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJbMarker);
export default __webpack_public_path__ + "static/media/JBMarker.4b9ec6a75ed9274f0cafccaad818949e.svg";
export { ForwardRef as ReactComponent };